class EqualHeight {

	constructor(blockEl) {
		this.el = blockEl;
		this.targets = this.el.querySelectorAll('.equal-height-target');
		this.desktopBreakpointSlider = 769;
		this.desktopBreakpointLinkCards = 641;


		this.init();
		window.addEventListener('resize', this.onResize.bind(this));
	}

	async init() {
		const isMobileLinkCards = window.innerWidth < this.desktopBreakpointLinkCards;

		// Exception
		if (isMobileLinkCards && this.el.classList.contains('block-link-cards__row') && this.el.classList.contains('equal-height') ) {
			this.targets.forEach(target => (target.style.height = 'auto'));
			return;
		}

		this.targets.forEach(target => (target.style.height = 'auto'));
		const maxHeight = await this.getHeights();
		this.equalizeHeights(maxHeight);
	}
	
	async getHeights() {
		let maxHeight = 0; 
		this.targets.forEach(target => {
			const targetHeight = target.offsetHeight;
			if (targetHeight > maxHeight) {
				maxHeight = targetHeight;
			}
		});

		return maxHeight;
	}

	equalizeHeights(maxHeight) {
		this.targets.forEach(target => {
			target.style.height = maxHeight + 'px';
		});
	}
	onResize() {
		this.init();
	}

}

export default EqualHeight;